import { Box } from "@mui/material";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import { StyledTwoChildContainer } from "../../StyledComponents/Container";
import Grid from "@mui/material/Grid2";
import CustomTextField from "../../../../shared/CustomTextFeild";
import CustomDatePicker from "../../../../shared/CustomDate";

const CommonComponet: React.FC<any> = ({ data }) => {
    const {
        loanNumber,
        source,
        description,
        isRecurring,
        frequency,
        endDate,
        amount,
        autoDebit,
        beginningDate
    } = data;
    const { t } = useTranslation();
    const translate = t as (key: string) => string;

    const autoDebitOptions = [
        { label: "On Due Date", value: "OnDueDate" },
        { label: "3 days before due date", value: "3daysBeforeDueDate" }
    ];
    const frequencyOptions = [
        { label: "For the life of the loan", value: "forTheLifeTimeOfLoan" },
        { label: "Only till", value: "onlyTill" }
    ];

    const amountOptions = [
        { label: "Choose one...", value: "All" },
        { label: "Statement Due", value: "statementDue" }
    ];

    const selectedautoDebit = autoDebitOptions.find(option => option.value === (autoDebit?.value || autoDebit));
    const selectedFrequency = frequencyOptions.find(option => option.value === (frequency?.value || frequency));
    const selectedAmount = amountOptions.find(option => option.value === (amount?.value || amount));


    return (
        <StyledTwoChildContainer>
            <Grid container spacing={2} sx={{ padding: '40px' }}>
                <Grid size={{ xs: 12, sm: 6, lg: 4 }} direction={'column'}>
                    <Box sx={{ mb: 2 }}>
                        <CustomTextField
                            labelText={translate('loanNumber')}
                            value={loanNumber?.loanNumber || loanNumber}
                            readOnly={true}
                        />
                    </Box>
                    <Box sx={{ mb: 2 }}>
                        <CustomTextField
                            labelText={translate('source')}
                            value={source?.fundName || source}
                            readOnly={true}
                        />
                    </Box>
                </Grid>
                <Grid size={{ xs: 12, sm: 6, lg: 4 }} alignItems="stretch">
                    <CustomTextField
                        labelText={translate('description')}
                        multiline
                        rows={5.3}
                        value={description}
                        readOnly={true}
                    />
                </Grid>
                <Grid size={{ xs: 12, sm: 0, lg: 4 }} sx={{ display: { sm: "none", xs: "block", lg: "block" } }}></Grid>
                <Grid size={{ xs: 12, sm: 6, lg: 4 }} >
                    <CustomTextField
                        labelText={translate('recurring')}
                        value={isRecurring ? 'Yes' : 'No'}
                        readOnly={true}
                    />
                </Grid>
                {isRecurring && <Grid size={{ xs: 12, sm: 6, lg: 4 }} >
                    <CustomTextField
                        labelText={translate('frequency')}
                        value={selectedFrequency?.label}
                        readOnly={true}
                    />
                </Grid>}
                {isRecurring && (frequency?.value || frequency) != "onlyTill" && <Grid size={{ xs: 12, sm: .1, lg: 4 }} sx={{ display: { xs: "none", lg: "block" } }}></Grid>}
                {isRecurring && (frequency?.value || frequency) == "onlyTill" && <Grid size={{ xs: 12, sm: 6, lg: 4 }} >
                    <CustomDatePicker
                        labelText={translate('endDate')}
                        value={endDate ? dayjs(endDate) : null}
                        readOnly={true}
                    />
                </Grid>}
                {isRecurring && frequency?.value == "onlyTill" && <Grid size={{ xs: 12, sm: 6, lg: 0 }} sx={{ display: { lg: "none", xs: "block" } }} ></Grid>}
                <Grid size={{ xs: 12, sm: 6, lg: 4 }} >
                    <CustomTextField
                        labelText={translate('amount')}
                        value={selectedAmount?.label || " "}
                        readOnly={true}
                    />
                </Grid>
                {!isRecurring && <Grid size={{ xs: 12, sm: 0, lg: 4 }} ></Grid>}
                <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
                    <CustomTextField
                        labelText={translate('autoDebit')}
                        value={selectedautoDebit?.label || " "}
                        readOnly={true}
                    />
                </Grid>
                {isRecurring && <Grid size={{ xs: 12, sm: 0, lg: 4 }} sx={{ display: { xs: "none", lg: "block" } }}></Grid>}
                <Grid size={{ xs: 12, sm: 6, lg: 4 }} >
                    <CustomTextField
                        labelText={translate('beginningDate')}
                        value={beginningDate}
                        readOnly={true}
                    />
                </Grid>
            </Grid>
        </StyledTwoChildContainer>
    );
}

export default CommonComponet;
